export default "__VITE_ASSET__DxkqigjN__"